"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactJss = require("react-jss");

var _jss = require("jss");

var _jssPluginNested = _interopRequireDefault(require("jss-plugin-nested"));

var _jssPluginGlobal = _interopRequireDefault(require("jss-plugin-global"));

const jss = (0, _jss.create)();
jss.use((0, _jssPluginNested.default)());
jss.use((0, _jssPluginGlobal.default)());

const ThemeProviderCustom = ({
  children,
  theme
}) => _react.default.createElement(_reactJss.ThemeProvider, {
  jss: jss,
  theme: theme
}, children);

var _default = ThemeProviderCustom;
exports.default = _default;